export default "__VITE_ASSET__CmH$39j3__"